module.exports = __webpack_public_path__ + "static/fonts/Helvetica.975df2b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Helvetica.ttf
// module id = Fp9y
// module chunks = 1